import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import DashboardNew from '../views/DashboardNew.vue'
import MyProducts from '../views/MyProducts.vue'
import Myfundmanager from '../views/Myfundmanager.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Profiling from '../views/Profiling.vue'
import AllRobot from '../views/Myrobot.vue'
import RobotDetail from '../views/RobotDetail.vue'
import BrokerRobot from '../views/BrokerRobot.vue'
import BrokerDetail from '../views/BrokerDetail.vue'
import FundManagerDetail from '../views/FundManagerDetail.vue'
import BrokerFundmanager from '../views/BrokerFundmanager.vue'
import BrokerFundDetail from '../views/BrokerFundDetail.vue'
import BankAccount from '../views/BankAccount.vue'
import AddBank from '../views/AddBank.vue'
import EditBank from '../views/EditBank.vue'
import Payment from '../views/Payment.vue'
import Activation from '../views/Activation.vue'
import ActivateRobot from '../views/ActivateRobot.vue'
import Subscriptions from '../views/Subscriptions.vue'
import EditProfile from '../views/EditProfile.vue'
import EditProfileDash from '../views/EditProfileDash.vue'
import WaitingApprove from '../views/WaitingApprove.vue'
import TypeIB from '../views/Type_IB.vue'
import ResetPassword from '../views/ResetPassword.vue'
import ChangePassword from '../views/ChangePassword.vue'
import IB from '../views/Introduction_broker/Dashboard.vue'
import InvestorIB from '../views/Introduction_broker/Investor_list.vue'
import CurrentBonus from '../views/Introduction_broker/Current_bonus.vue'
import NotIB from '../views/Introduction_broker/NotIB.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/profile/update',
    name: 'EditProfile',
    component: EditProfile
  },
  {
    path: '/profile/edit',
    name: 'EditProfileDash',
    component: EditProfileDash
  },
  {
    path: '/profile/change-password',
    name: 'ChangePassword',
    component: ChangePassword
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/waiting',
    name: 'WaitingApprove',
    component: WaitingApprove
  },
  {
    path: '/introduction-broker',
    name: 'IB',
    component: IB
  },
  {
    path: '/introduction-broker/request',
    name: 'NotIB',
    component: NotIB
  },
  {
    path: '/dash',
    name: 'DashboardNew',
    component: DashboardNew
  },
  {
    path: '/my-products/robots',
    name: 'MyProducts',
    component: MyProducts
  },
  {
    path: '/my-products/fund-manager',
    name: 'Myfundmanager',
    component: Myfundmanager
  },
  {
    path: '/profiling',
    name: 'profiling',
    component: Profiling
  },
  {
    path: '/all-robot',
    name: 'allrobot',
    component: AllRobot
  },
  {
    path: '/robot/:id',
    name: 'RobotDetail',
    component: RobotDetail
  },
  {
    path: '/robot/:id/broker',
    name: 'BrokerRobot',
    component: BrokerRobot
  },
  {
    path: '/robot/:id/broker/detail/:broker_id',
    name: 'BrokerDetail',
    component: BrokerDetail
  },
  {
    path: '/fund-manager/:id',
    name: 'FundManagerDetail',
    component: FundManagerDetail
  },
  {
    path: '/fund-manager/:id/broker',
    name: 'BrokerFundmanager',
    component: BrokerFundmanager
  },
  {
    path: '/fund-manager/:id/broker/detail/:broker_id',
    name: 'BrokerFundDetail',
    component: BrokerFundDetail
  },
  {
    path: '/bank-account',
    name: 'BankAccount',
    component: BankAccount
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    component: Subscriptions
  },
  {
    path: '/payment/:id',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/activation/:id',
    name: 'Activation',
    component: Activation
  },
  {
    path: '/activation/robot/:id',
    name: 'ActivateRobot',
    component: ActivateRobot
  },
  {
    path: '/bank-account/add-card',
    name: 'AddBank',
    component: AddBank
  },
  {
    path: '/bank-account/edit-card/:id',
    name: 'EditBank',
    component: EditBank
  },
  {
    path: '/introduction-broker/type',
    name: 'TypeIB',
    component: TypeIB
  },
  {
    path: '/introduction-broker/investor',
    name: 'InvestorIB',
    component: InvestorIB
  },
  {
    path: '/current-bonus',
    name: 'CurrentBonus',
    component: CurrentBonus
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  // {
  //   path: '/dash',
  //   name: 'Dash',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../Dashboad.vue')
  // },
  {
    path: '/profile',
    name: 'Profile',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Profile.vue')
  },
  {
    path: '/my-robot',
    name: 'Myrobot',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Myrobot.vue')
  },
  {
    path: '/request-ib-status',
    name: 'IBstatus',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/IBstatus.vue')
  },
  {
    path: '/data-bank',
    name: 'Databank',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Databank.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/forgot-password',
    name: 'Forgot_password',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Forgot_password.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/home', '/forgot-password', '/resetpassword'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('access_token');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});

export default router
